import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconTips20pxRegular = function IconTips20pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.223 11.271c.853-.786 1.277-1.888 1.277-3.166C15.5 4.988 13.017 2.5 10 2.5S4.5 4.988 4.5 8.105c0 1.278.424 2.38 1.276 3.166l.295.27c.82.745 1.877 1.706 2.568 2.959h2.722c.691-1.253 1.748-2.214 2.568-2.96l.294-.269zm.743 1.355c-1.074.983-2.18 1.996-2.632 3.37a.005.005 0 01-.004.004H7.67a.005.005 0 01-.004-.003c-.452-1.375-1.558-2.388-2.632-3.371l-.274-.252C3.546 11.255 3 9.724 3 8.105 3 4.181 6.134 1 10 1s7 3.181 7 7.105c0 1.619-.546 3.15-1.76 4.269l-.274.252z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.28 18.09a.91.91 0 01.909-.908h3.636a.91.91 0 010 1.818H8.19a.91.91 0 01-.91-.91z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.189 17.182a.91.91 0 100 1.818h3.636a.91.91 0 000-1.818H8.19z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.106 4.895a.75.75 0 01.061 1.058L9.851 7.432h1.97a.75.75 0 01.56 1.249l-2.428 2.727a.75.75 0 01-1.12-.998l1.316-1.478H8.18a.75.75 0 01-.56-1.249l2.428-2.727a.75.75 0 011.059-.061z"
    })]
  }));
};
export default IconTips20pxRegular;